// Variant-keuze op product-cards (collectie/zoeken). Werkt met event-delegation,
// dus overleeft AJAX-render van de facets zonder herbinding.
(() => {
  const parseVariants = (card) => {
    const el = card.querySelector('[data-card-variant-json]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch { return []; }
  };

  const update = (card) => {
    const variants = parseVariants(card);
    const groups = [...card.querySelectorAll('[data-opt-index]')];
    const selected = groups.map((g) => g.querySelector('.pc-opt.is-active')?.dataset.optValue);
    const match = variants.find((v) => v.options.every((o, i) => o === selected[i]));

    const root = card.closest('.pc-card');
    const form = root?.querySelector('[data-add-to-cart]');
    const idInput = form?.querySelector('input[name="id"]');
    const btn = form?.querySelector('.pc-add');

    if (match && idInput) idInput.value = match.id;
    if (btn) {
      const avail = match ? match.available : false;
      btn.disabled = !avail;
      btn.classList.toggle('pc-add--off', !avail);
    }
    // Voorraadregel meeschakelen. Zelfde staten als snippets/stock-level.liquid:
    // alleen een getrackte variant (`t`) mag een aantal tonen, niet-getrackt geeft -1.
    const line = root?.querySelector('[data-stock-line]');
    const label = line?.querySelector('[data-stock-label]');
    if (line && label) {
      const low = Number(root.dataset.lowStock || 0);
      let state = 'ok';
      let text = 'Op voorraad';
      if (!match || !match.available) {
        state = 'oos';
        text = 'Tijdelijk uitverkocht';
      } else if (match.t && match.q > 0 && match.q <= low) {
        state = 'low';
        text = `Nog ${match.q} op voorraad`;
      }
      line.dataset.stockState = state;
      label.textContent = text;
    }
    if (match && window.formatMoney) {
      const priceEl = root?.querySelector('.pc-price, .pc-priceSale');
      if (priceEl) priceEl.textContent = window.formatMoney(match.price);
    }
    if (match && match.image) {
      const img = root?.querySelector('.pc-img');
      if (img && img.src !== match.image) {
        img.src = match.image;
        img.removeAttribute('srcset');
      }
    }
  };

  // "+N" klapt de rest van de optiegroep uit. Delegatie, net als de opties zelf,
  // zodat een AJAX-render van de facets niets hoeft te herbinden.
  document.addEventListener('click', (e) => {
    const more = e.target.closest('.pc-optMore');
    if (!more) return;
    const group = more.closest('[data-opt-index]');
    if (!group) return;
    group.classList.add('is-expanded');
    more.setAttribute('aria-expanded', 'true');
  });

  document.addEventListener('click', (e) => {
    const opt = e.target.closest('.pc-opt');
    if (!opt) return;
    const group = opt.closest('[data-opt-index]');
    group.querySelectorAll('.pc-opt').forEach((b) => b.classList.remove('is-active'));
    opt.classList.add('is-active');
    update(opt.closest('[data-card-variants]'));
  });
})();
